(function () {
  // Initialize heatmaps
  let dailyAvgHeatmap;
  let daily15MinHeatmap;

  // Initialize scales for heatmaps
  const scales = {
    8: {
      breaks: [0, 4, 8, 12, 16, 20, 24.19, 24.2],
      colors: ['#4e65ac', '#6869af', '#5ca7ba', '#addeac', '#e1f3aa', '#f6fbb5', '#ff9b93', '#e6665c'],
    }, // Temp
  };

  /**
   * This function is used to validate if properties on an object exist
   * @param {*} props
   * @param {*} obj
   * @param {*} msg
   */
  function validateProps(props, obj, msg = 'Error: Please resolve the following:') {
    let errors = props
      .map(prop => {
        if (typeof obj[prop] === 'undefined') {
          return `No value provided for the ${prop} property \n`;
        }
        return 0;
      })
      .filter(prop => prop !== 0);
    if (errors.length > 0) {
      throw `${msg} \n ${errors.join('')}`;
    }
  }

  function createRequestURL(req = {}) {
    validateProps(['url', 'table', 'fields'], req, 'Error creating the daily request url:');
    const { url, table, fields } = req;
    return `${url}?table=${table}&fields%5b%5d=${fields}&drupal_user_switch=false&drupal_userid=1`;
  }

  function create15minRequestURL(req = {}) {
    validateProps(
      ['url', 'table', 'fields', 'date_field', 'date_value'],
      req,
      'Error creating the 15 min request url:'
    );
    const { url, table, fields, date_field, date_value } = req;
    return `${url}?table=${table}&fields%5b%5d=${fields}&date_field=${date_field}&date_value='${date_value}'&drupal_user_switch=false&drupal_userid=1`;
  }

  function filterData(data) {
    const startDateVal = startDate.getDate();
    const endDateVal = endDate.getDate();
    return data.filter(
      d =>
        moment(d.rdate).isSameOrAfter(startDateVal) &&
        moment(d.rdate).isSameOrBefore(endDateVal) &&
        d.daily_average !== null
    );
  }

  /**
   * This function is used to format data for the 15 min heatmap
   * @param {*} data
   * @param {*} resultField
   * @param {*} dateField
   */
  function formatData(data, resultField, dateField) {
    return data.map(d => {
      return {
        rdate: d[dateField],
        depth_value: parseInt(d.depth_value),
        rvalue: +d[resultField],
        unit_name: d.unit_name,
        parameterid: '8',
      };
    });
  }

  /**
   * This function is used as shorthand for creating a Mercury Form filter control
   * @param  {string} type  [type of filter to create i.e. dropdown or date filter]
   * @param  {string} label [label to display above filter]
   * @return {object}       [returns a mercury form object]
   */
  function createFilter(type, label) {
    let options = {
      parentContainer: '#filters-wrapper',
      label: label,
    };

    if (type === 'date') {
      return new datePicker(options);
    } else if (type === 'dropdown') {
      return new Dropdown(options);
    }
  }

  function updateGraphTitles(date) {
    const daily15minTitle = document.querySelector('#daily-15-min-graph-title');

    if (typeof date !== 'undefined') {
      daily15minTitle.textContent = `15 Minute Temperature Data on ${date}`;
    } else {
      daily15minTitle.textContent = `15 Minute Temperature Data`;
    }
  }

  /**
   * This function is used to bind the onChange event for each filter
   * The function loops through each filter and binds the createResultRequest function to the filter
   * @return {[type]} [description]
   */
  function bindFilterEvents(data) {
    const filters = [startDate, endDate];
    filters.forEach(filter => {
      filter.onChange = () => {
        if (typeof daily15MinHeatmap !== 'undefined') {
          daily15MinHeatmap.removeSVG(
            '<p style="margin-top: -115px;" class="margin-left alert alert-success col-sm-5">Click on a cell in the daily averages heatmap to view 15 minute data for a specific day.</p>'
          );
        }
        const filteredData = filterData(data);
        drawDailyAvgHeatmap(filteredData);
        updateGraphTitles();
      };
      filter.bindEvents();
    });
  }

  function setBottomDepth() {
    d3.selectAll('.row-label').text(d => {
      if (d === 9999) {
        return 'Bottom';
      }
      return `${d} m`;
    });
  }

  // Create an async function as a shorthand for resolving fetch requests
  async function fetchData(url) {
    let response = await fetch(url);
    let json = await response.json();
    return json;
  }

  function draw15MinHeatmap(data) {
    daily15MinHeatmap = new Heatmap({
      container: '#daily-15-min-heatmap',
      data: formatData(data, 'result_value', 'rtimestamp'),
      xAxis: {
        enabled: true,
        alternateLabelEvery: 4,
        minCellSize: 13,
        format: 'yyyy-mm-dd hh:mm:ss',
      },
      yAxis: {
        enabled: true,
        alternateLabelEvery: 1,
        minCellSize: 30,
      },
      scale: scales['8'],
    });
    daily15MinHeatmap.draw();
  }

  function drawDailyAvgHeatmap(data) {
    dailyAvgHeatmap = new Heatmap({
      container: '#daily-avg-heatmap',
      data: formatData(data, 'daily_avg', 'rdate'),
      xAxis: {
        enabled: true,
        alternateLabelEvery: 10,
        minCellSize: 7.5,
      },
      yAxis: {
        enabled: true,
        alternateLabelEvery: 1,
        minCellSize: 30,
      },
      scale: scales['8'],
      events: {
        click: d => {
          const daily15minRequestURL = create15minRequestURL({
            url: 'sites/all/scripts/view/real-time-res-data.php',
            table: 'viewer.thermistor_data_results_viewer_15_min_table',
            fields: ['*'],
            date_field: 'rdate',
            date_value: d.rdate,
          });
          updateGraphTitles(moment(d.rdate).format('MM/DD/YYYY'));
          const daily15minPromise = fetchData(daily15minRequestURL);
          daily15minPromise.then(json => {
            draw15MinHeatmap(json);
            setBottomDepth();
          });
        },
      },
    });
    dailyAvgHeatmap.draw();
  }

  const dailyRequestURL = createRequestURL({
    url: 'sites/all/scripts/view/',
    table: 'viewer.thermistor_data_results_viewer_table_daily',
    fields: ['*'],
  });

  // Create filters
  const startDate = createFilter('date', 'Start Date');
  const endDate = createFilter('date', 'End Date');

  startDate.setDate('2024-04-01');
  endDate.setDate('2024-10-31');

  const resultsPromise = fetchData(dailyRequestURL);

  // Request initial data from the DB
  resultsPromise
    .then(data => {
      const filteredData = data.filter(
        d => moment(d.rdate).isSameOrAfter('2024-04-01') && moment(d.rdate).isSameOrBefore('2024-10-31')
      );
      drawDailyAvgHeatmap(filteredData);
      bindFilterEvents(data);
      setBottomDepth();
    })
    .catch(err => {
      if (err) throw err;
    });
})();
